import _ from 'lodash'
import {getCompareByItems,getGroupByItems,getViewItems} from './components/Dropdown'

export const NAME = "analytics_metric";

export const processGroupBy=(groupBy:string, usBased:boolean, stateLevel:boolean=false)=>{
  let processedGroupBy = groupBy
  if(groupBy=='region'){
    //default to dma/fsa level data, state if stateLevel == true  (for map view)
    processedGroupBy = stateLevel? 'state' : usBased? 'dma':'fsa'
  }
  return processedGroupBy
}

export const defaultGroupBy=(metric:string, view?:string, features?: any) => {
  switch(metric){
    case 'impressions':
    case 'average_time_on_flyer':
      if(view=='pie' || view =='bar'){return 'publication'}
    case 'opens':
    case 'unique_engaged_visits':
    case 'clicks':
      if(view == 'pie' || view == 'bar'){return 'publication'}
      if(view == 'map'){return 'region'}
      if(view == 'content'){return 'item'}
      if(view=='line'){return 'date'}
    case 'spend':
      if(view=='table'){return 'budget'}
      if(view == 'line'){return 'date'}
      if(view == 'pie' || view == 'bar'){return 'publication'}
    case 'item_views':
      if(view == 'line'){return 'date'}
      if(view == 'bar'){return 'item'}
    case 'shopping_list':
      if(view == 'bar' || 'content'){return 'item'}
    case 'ttm':
      if(view == 'content'){return 'item'}
      if(view == 'map' || view == 'bar' || view == 'pie'){

        // Hack to hide region for bar and pie using feature flags
        if (view != 'map' && features && !features['bar_view_group_by_region'])
          return 'item'
        return 'region'
      }
    default:
      return null
  }
}

export const defaultView=(metric:string)=>{
  switch(metric){
    case 'impressions':
    case 'average_time_on_flyer':
    case 'opens':
    case 'unique_engaged_visits':
    case 'clicks':
      return 'line'
    case 'spend':
      return 'table'
    case 'item_views':
    case 'shopping_list':
      return 'bar'
    case 'ttm':
      return 'map'
    default:
      return null
  }
}

export const group_by_to_data_key_transformation = (metric:string, groupBy:string) => {
  switch(groupBy){
    case 'date':
      return 'date'
    case 'publication':
      return 'flyer_run_name'
    case 'device':
      return 'device'
    case 'channel':
      return 'channel'
    case 'fsa':
      return 'fsa'
    case 'dma':
      return 'dma'
    case 'state':
      return'state'
    case 'item':
      return'master_flyer_item_name'
    case 'section':
      return'master_flyer_item_page_position'
    case 'days_since_flyer_launch':
      return 'days_since_flyer_launch'
    default:
      return null
  }
}

export const formatYAxisLabel=(metric:string)=>{
  switch(metric){
    case 'impressions':
    case 'opens':
    case 'unique_engaged_visits':
    case 'clicks':
    case 'shopping_lists':
    case 'ttm':
    case 'item_views':
      return `Number of ${_.startCase(metric.split("_").join(' '))}`
    case 'average_time_on_flyer':
      return _.startCase(metric.split("_").join(' '))
    case 'spend':
      return "Amount Spent"
    default:
      return `Total ${_.startCase(metric.split("_").join(' '))}`
  }
}

export const formatXAxisLabel=(group_by:string)=>{
  switch(group_by){
    case 'flyer_type':
    case 'flyer_run_name':
      return 'Publications'
    case 'master_flyer_item_name':
      return 'Items'
    case 'master_flyer_item_page_position':
      return 'Sections'
    case 'publication':
    case 'device':
    case 'channel':
    case 'state':
    case 'item':
      return `${_.startCase(group_by)}s`
    case 'date':
      return _.startCase(group_by)
    case 'fsa':
    case 'dma':
      return group_by.toUpperCase()
    case 'days_since_flyer_launch':
      return _.startCase(group_by.split("_").join(' '))
    default:
      return group_by

  }
}

export const defaultYTickProps={isNumeric:true,style:{'fontSize':'11px', 'fontWeight':500}}
export const defaultXTickProps={isNumeric:false, textAlign: 'middle', yPadding:10, style:{'fontSize':'11px', 'fontWeight':500}}
export const defaultYLabelProps=(metric:string)=>({style:{'fontStyle': 'bold','fontSize':'14px'}, isVertical:true, padding:10, value: formatYAxisLabel(metric), textAlign:'middle' })
export const defaultXLabelProps=(group_by:string)=>({style:{'fontStyle': 'bold','fontSize':'14px'}, isVertical:false, padding:10, value: formatXAxisLabel(group_by), textAlign:'middle' })

export const validateDropDowns = (metric:string, group_by:string, compare_by:string, view:string)=>{
  let  viewItems = getViewItems(metric)
  let comparelessMetrics = ['spend','item_views','shopping_list','ttm']
  if(metric && viewItems && viewItems[`${view}_view`]){
    let groupByItems = getGroupByItems(metric, view) as any
    let compareByItems = getCompareByItems(metric, view, group_by)

    return groupByItems[`group_by_${group_by}`] &&
      (compareByItems[`compare_by_${compare_by}`] ||
      !compare_by ||
      comparelessMetrics.indexOf(metric)>0 ||
      (metric == 'clicks' && ((group_by == 'region' && ['map', 'bar', 'pie'].indexOf(view)>0) || (group_by =='item' && view == 'content'))|| (view=='pie' && ['publication', 'device', 'channel'].indexOf(group_by)>0)) ||
      (['opens', 'unique_engaged_visits', 'page_views'].indexOf(metric)>0) && ((group_by == 'region' && ['map', 'bar', 'pie'].indexOf(view)>0) || (view=='pie' && ['publication', 'device', 'channel'].indexOf(group_by)>0))
    )
  }
}

export const hasFinancePermissions = (permissions: any, merchant: any) => {
  return (permissions.access_marketplace_dashboard_finance &&
       (permissions.access_marketplace_dashboard_finance.Merchant == true ||
       permissions.access_marketplace_dashboard_finance.Merchant.includes(parseInt(merchant))))
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/constants.ts